import Store from "redux/store";
import jwt_decode from "jwt-decode";

const Auth = {
  isAuthenticated: () => {
    // To check if the user is authenticated or not
    if (localStorage.getItem("token")) {
      let expiry = Auth.decodedToken().exp * 1000;
      if (!(new Date(expiry) > new Date())) {
        Auth.LogoutUser();
        return false;
      }
      return true;
    }
    return false;
  },
  LogoutUser: () => {
    ["token", "token_decoded"].forEach((i) => {
      localStorage.removeItem(i);
    });
    Store.dispatch({ type: "LogoutUser" });
  },
  saveToken: (token) => {
    localStorage.setItem("token", token);
  },
  LoginUser: (token) => {
    var decoded = jwt_decode(token);
    localStorage.setItem("token", token);
    localStorage.setItem("token_decoded", JSON.stringify(decoded));
    Store.dispatch({ type: "LoginUser" });
  },
  decodedToken: () => {
    return jwt_decode(localStorage.getItem("token"));
  },
};
export default Auth;
